export default () => {
  // Your own project level JS may go here
  // console.log('Hello World from the asset/ui/src/index.js');

};
